/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicReservationPaymentPathParameters } from 'api/actions/get-public-reservation-payment/get-public-reservation-payment-path-parameters';
import { GetPublicReservationPaymentResponse } from 'api/actions/get-public-reservation-payment/get-public-reservation-payment-response';

type GetPublicReservationPaymentQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicReservationPayment action.
 */
export const getPublicReservationPaymentActionPath = new SweetPath<keyof GetPublicReservationPaymentPathParameters>(
  '/reservations/public/payments/{accessToken}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicReservationPayment actions.
 */
export default function createGetPublicReservationPaymentAction(axios: AxiosInstance) {
  return function getPublicReservationPaymentAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicReservationPaymentPathParameters;
    query?: GetPublicReservationPaymentQueryParameters;
  }) {
    const path = getPublicReservationPaymentActionPath.insert(parameters);

    return axios.get<GetPublicReservationPaymentResponse, GetPublicReservationPaymentResponse>(path, {
      params: query,
      headers,
    });
  };
}
